import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';


var firebaseConfig = {
  apiKey: "AIzaSyDS8vRXt7LDN4RM3a6ZZqkKXEKhbP9uijY",
  authDomain: "frictionmapper-d6cba.firebaseapp.com",
  databaseURL: "https://frictionmapper-d6cba.firebaseio.com",
  projectId: "frictionmapper-d6cba",
  storageBucket: "frictionmapper-d6cba.appspot.com",
  messagingSenderId: "339014662803",
  appId: "1:339014662803:web:3396cc3250631ed8166b66",
  measurementId: "G-MZLTZ9Y571"
};

firebase.initializeApp(firebaseConfig);

export const auth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();

export const db = firebase.firestore();